import { API_URL } from "@/config";

export const paths={
    Reports:"/reports",
    accounting:'/accounting',
    payments:"/payments",
    superadminDashboard:"/superadmin/dashboard",
    ACRecievable:"/reports/AccountsReceiveable",
    AccountsPayable:"/reports/AccountsPayable",
    ProfitAndLossReport:"/reports/profit-and-loss",
    BalanceSheetReport:"/reports/balance-sheet",
    chartofaccounts:"/chart-accounts",
    estimates:"/accounting/sales/estimates",
    accountinvoices:"/accounting/sales/invoices",
    accountrecievedpayment:"/accounting/sales/accounts/recievedpayment",
    accountpayable:"/accounting/purchase/accounts/recievedbill",
    dashboard:"/dashboard",
    dynamicFieldMaster:"/settings/dynamic-fields",
    customFieldMaster:"/settings/custom-fields",
    createload:"/createload",
    viewload:"/loads",
    customers:"/customers",
    carriers:"/carriers",
    drivers:"/drivers",
    documents:"/documents",
    expensefeeslist:"/expensefeeslist",
    paymentterms:"/payment-terms",
    invoiceReminderTemplates:"/invoice-reminder-templates",
    productservices:"/productservices",
    taxoptions:"/taxoptions",
    JournalEntry:"/journalentry",
    JournalEntryList:"/journal-entry-list",
    users:"/users",
    plans:"/plans",
    register:"/register",
    login:"/login",
    shortcuts:"/shortcuts",
    accountspayable:"/accounts/payable",
    accountsreceivable:"/accounts/receivable",
    expenses:"/accounts/expenses",
    income:"/accounts/income",
    sales:"/accounts/sales",
    reportprofitandloss:"/reports/profit-and-loss",
    notauthorized:"/403",
    notfound:"/404",
    NotAuthorized:"/403",
    //  without forward slash
    AccountRegister:"/chart-accounts/AccountRegister",
    vendortransactionlist:"/vendortransactionlist",
    editload:"/editload",
    viewcompany:"/company",
    recievedpayment:"/recievedpayment",
    recievedbill:"/recievedbill",
    customertransactionlist:"/customertransactionlist",
    editinvoice:"/editinvoice",
    editbill:"/editbill",
    base64imageviewer:`${API_URL}api/accounts`,
    base64estimateviewer:"/baseestimateviewer",
    forgetpassword:"/forgetpassword",
    resetpassword:"/reset-password",
    generateInvoice:"/generateonvoice",
    billpay:"/billpay",
    vinLookup:"/vin-lookup",
    dispatcher:"/dispatcher",
    creditNotes:"/accounting/credit-notes",
    creditNoteCreate:"/accounting/credit-notes/create",
    creditNoteView:"/accounting/credit-notes/view",
    debitNotes:"/accounting/debit-notes",
    debitNoteCreate:"/accounting/debit-notes/create",
    debitNoteView:"/accounting/debit-notes/view",
    // NOTE: above paths match the output of generateRoutes(/accounting + /credit-notes/...)

}